module.exports = __webpack_public_path__ + "img/banner.fe3c6a89.png";